import type { EChartsOption } from "echarts";

/** Спільна вотермарка для графіків ECharts (CCU, Reviews тощо) */
export function getEchartsWatermark(): EChartsOption["graphic"] {
  return [
    {
      type: "group",
      left: "center",
      top: "middle",
      scale: [2, 2],
      rotation: (28 * Math.PI) / 180,
      z: 0,
      children: [
        {
          type: "text",
          left: -85,
          top: -12,
          style: {
            text: "steampeek.app",
            fontSize: 22,
            fill: "rgba(143, 152, 160, 0.32)",
            fontFamily: "inherit",
          },
        },
      ],
    },
  ] as EChartsOption["graphic"];
}
